export type IsbarSections = {
  identification?: Record<string, unknown>;
  situation?: Record<string, unknown>;
  background?: Record<string, unknown>;
  assessment?: Record<string, unknown>;
  recommendation?: Record<string, unknown>;
};

export type IsbarValidationResult = {
  valid: boolean;
  missingSections: Array<keyof IsbarSections>;
};

export const ISBAR_SECTION_LABELS: Record<keyof IsbarSections, string> = {
  identification: 'Identification',
  situation: 'Situation',
  background: 'Background',
  assessment: 'Assessment',
  recommendation: 'Recommendation',
};

const REQUIRED_ISBAR_SECTIONS: Array<keyof IsbarSections> = [
  'identification',
  'situation',
  'background',
  'assessment',
  'recommendation',
];

function sectionHasContent(section: Record<string, unknown> | undefined): boolean {
  if (!section) return false;
  return Object.values(section).some((value) => {
    if (value === null || value === undefined) return false;
    if (typeof value === 'string') return value.trim().length > 0;
    if (Array.isArray(value)) return value.length > 0;
    if (typeof value === 'object') return Object.keys(value).length > 0;
    return true;
  });
}

export function validateIsbarSections(sections: IsbarSections): IsbarValidationResult {
  const missingSections = REQUIRED_ISBAR_SECTIONS.filter(
    (sectionName) => !sectionHasContent(sections[sectionName]),
  );
  return { valid: missingSections.length === 0, missingSections };
}

export function buildIsbarSummary(sections: IsbarSections): string {
  return REQUIRED_ISBAR_SECTIONS.map((sectionName) => {
    const section = sections[sectionName] ?? {};
    const values = Object.values(section)
      .map((value) => (typeof value === 'string' ? value.trim() : ''))
      .filter(Boolean);
    return `${ISBAR_SECTION_LABELS[sectionName]}: ${values.join(' ') || 'Not recorded'}`;
  }).join('\n');
}
